const compressed = ref(false);

export function useCompressed() {
  const toggleCompressed = () => {
    if (process.client) {
      localStorage.setItem('compressed', (!compressed.value).toString());
    }
    compressed.value = !compressed.value;
  };

  onMounted(() => {
    compressed.value = !!localStorage?.getItem('compressed');
  });

  return {
    compressed,
    toggleCompressed,
  };
}
